<template>
  <div>
    <!-- <b-card no-body>
      <b-card-header>
        <b-row align-v="center">
          <b-col class="text-left">QR Code of {{kios_name}}</b-col>
          <b-col class="text-right"><b-button onclick="printJS({ printable: 'printQRCode', type: 'html', style: '#printQRCode {color:#008841; text-align:center;}' })" @click="test" variant="primary">Print</b-button></b-col>
        </b-row>
      </b-card-header>
      <b-card-body :id="'card-qr-code'" align="center">
        <div id="printQRCode" style="color: #008841">
          <qrcode-vue :value="qr_code_id" :size="160" level="H" foreground="#008841"></qrcode-vue>{{qr_code_id}}
        </div>
      </b-card-body>
    </b-card> -->
    <!-- <qrcode-vue :value="qr_code_id" :size="160" level="H" foreground="#008841"></qrcode-vue>{{qr_code_id}}. {{kios_name}} -->
    <qrcode-vue :value="qr_code_id" :size="160" level="H" foreground="#008841"></qrcode-vue>{{kios_name}}
  </div>
</template>

<script>
import printJS from 'print-js'
import $ from 'jquery'
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'QRCode',
  components: {QrcodeVue},
  props: ['qr_code_id', 'kios_name'],
  methods: {
    test: function(){
      // console.log('printtt', this.qr_code_id)
    }
  }
}
</script>
<style>
@media print {
  body * {
    visibility: hidden;
  }
  #section-to-print, #section-to-print * {
    visibility: visible;
  }
  #printQRCode {
    position: absolute;
    left: 0;
    top: 0;
  }
}
@print{
  @page :footer {color: #fff }
  @page :header {color: #fff}
}
</style>
